import React from 'react';
export function UndoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.507 7.005l-9.086-.013L7.716 5.7A1.001 1.001 0 106.3 4.284l-3 3a1 1 0 000 1.414l3 3a1 1 0 101.416-1.412L6.419 8.992l9.085.013a3.5 3.5 0 010 7h-.006l-7.5-.01a1 1 0 100 2l7.5.01h.002a5.5 5.5 0 00.007-11z"
  }));
}